import { Component } from '@angular/core';
import { Datalistviewcolumn, MultiIconViewColumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-valetinventory',
    templateUrl: './valetinventory.component.html',
    styleUrls: ['./valetinventory.component.scss'],
    standalone: false
})
export class ValetInventoryComponent {
  constructor(private apiService: ApiServiceBase) {
    this.apiService.Get<string[]>("workflows/states/ValetParkingSession/names").then(names => {
      this.Statuses = ["Open", "Priority", ...names];
    });
  }

  public Statuses: string[] = ["Open", "Priority"];

  public Columns: Array<Datalistviewcolumn> = [
    new Datalistviewcolumn("Id", "Id"),
    new Datalistviewcolumn("Ticket #", "TicketNumber"),
    new Datalistviewcolumn("License Plate", "ValetPlateNumber"),
    new Datalistviewcolumn("Key Tag", "KeyTagIdentifier"),
    new Datalistviewcolumn("Entry Date", "StartDateLocalString"),
    new Datalistviewcolumn("State", "CurrentStateName"),
    new Datalistviewcolumn("State Entered", "StateEnteredDateLocalFriendlyString"),
    new MultiIconViewColumn("", [
      { icon: 'dollar-sign', property: 'TotalOutstanding', activeColor: '3273dc', inactiveColor: 'b5b5b5', activeTitle: 'Paid', inactiveTitle: 'Unpaid', condition: (v) => v != null && v <= 0 },
      { icon: 'camera', property: 'DefaultMediaId', activeColor: '3273dc', inactiveColor: 'b5b5b5', activeTitle: 'Damage Check Complete', inactiveTitle: 'Damage Check Incomplete', condition: (v) => v != null }
    ])
  ];
}
